// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".deleted{-webkit-text-decoration-line:line-through;text-decoration-line:line-through;color:grey}", ""]);
// Exports
module.exports = exports;
